// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAkQAYdyg-idHskpF21YCQDHkuQSZsvvV4',
    authDomain: 'aztrace-nhatkycanhtac.firebaseapp.com',
    databaseURL:
      'https://aztrace-nhatkycanhtac-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'aztrace-nhatkycanhtac',
    storageBucket: 'aztrace-nhatkycanhtac.appspot.com',
    messagingSenderId: '305595108522',
    appId: '1:305595108522:web:2472ed17d98a0dce3754d3',
    measurementId: 'G-D8V5ZBVW8V',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
